module.exports = __webpack_public_path__ + "img/thumbs_up.fd5f8964.svg";